import { EscrowDashboardCardProvider } from '../model/context';

import type { IEscrowDashboardItemViewModel, IEscrowDashboardCardConfig } from '../model/types';

type RootProps = IEscrowDashboardCardConfig & {
  viewModel: IEscrowDashboardItemViewModel;
  children: React.ReactNode;
};

const Root = ({ viewModel, basePath, statusMap, onInvitationClick, infoListItems, children }: RootProps) => {
  const config: IEscrowDashboardCardConfig = {
    basePath,
    statusMap,
    onInvitationClick,
    infoListItems,
  };

  return <EscrowDashboardCardProvider value={{ viewModel, config }}>{children}</EscrowDashboardCardProvider>;
};

export { Root };
